<template>
    <div class="overflow-x-auto bg-white rounded-md font-normal">
        <table class="table-auto min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
                <tr class="text-left">
                    <th
                        v-for="heading in headings"
                        :key="heading"
                        scope="col"
                        class="p-2 text-xs font-bold text-gray-500 uppercase tracking-wider"
                    >
                        {{ heading }}
                    </th>
                    <th v-if="showOpen"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(task, index) in tasks"
                    :key="task.id"
                    :class="index % 2 == 0 ? 'bg-white' : 'bg-gray-50'"
                >
                    <td
                        class="p-2 whitespace-nowrap text-sm text-gray-700 font-bold"
                    >
                        {{ task.number }}
                    </td>
                    <td class="p-2 text-sm text-gray-500">
                        {{ task.farmer }}
                    </td>
                    <td class="p-2 text-sm text-gray-500">
                        {{ task.farms.join(", ") }}
                    </td>
                    <td class="p-2 whitespace-nowrap text-sm">
                        <span
                            class="px-2 py-0.5 rounded-full text-xs font-medium"
                            :class="task.status_class"
                        >
                            {{ task.status }}
                        </span>
                    </td>
                    <td class="p-2 whitespace-nowrap text-sm text-gray-500">
                        {{ task.samples_in_file }} of
                        {{ task.samples_on_task }}
                    </td>
                    <td v-if="showOpen" class="p-2 text-right">
                        <inertia-link
                            :href="task.url"
                            class="inline-flex justify-center py-1 px-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            Open task
                        </inertia-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        // CsvImport::taskSummaries()
        tasks: {
            type: Array,
            required: true,
        },
        showOpen: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            headings: ["Task", "Farmer", "Farm", "Status", "Samples in file"],
        };
    },
};
</script>
